"use client";

import { ChatGuardrailsContainer, StaticBubble, Bubble } from "./ChatGuardrailsShared";

const STATES = [
  "IDLE",
  "HIDE_PLACEHOLDER",
  "USER_1_0",
  "USER_1_1",
  "AGENT_1_0",
  "AGENT_1_1",
  "USER_2_0",
  "AGENT_2_0",
  "SHOW_ALL",
];

const AGENT_SPEAKING_STATES = ["AGENT_1_0", "AGENT_1_1", "AGENT_2_0"];

export function ChatGuardrailsTestAgents() {
  return (
    <ChatGuardrailsContainer
      backgroundImage='/assets/images/backgrounds/aqua-4-bg.png'
      avatarSrc='/assets/images/avatars/avatar_2.png'
      states={STATES}
      agentSpeakingStates={AGENT_SPEAKING_STATES}
    >
      {m => (
        <>
          <m.div
            className='tw-absolute tw-top-0 tw-inset-x-0'
            initial={{ opacity: 1 }}
            animate={{ HIDE_PLACEHOLDER: { opacity: 0 } }}
          >
            <StaticBubble sentences={["Hey there!", "Can I get a refund for my last order?"]} variant='user' />
            <StaticBubble
              sentences={[
                "Unfortunately, I cannot issue refunds.",
                "Would you like me to redirect you to a human support agent?",
              ]}
              className='tw-mt-2'
            />
            <StaticBubble sentences={["Yes, please!"]} variant='user' className='tw-mt-2' />
            <StaticBubble sentences={["Redirecting you now..."]} className='tw-mt-2' />
          </m.div>

          <Bubble
            m={m}
            step='USER_1'
            sentences={["Hey there!", "Can I get a refund for my last order?"]}
            variant='user'
          />
          <Bubble
            m={m}
            step='AGENT_1'
            sentences={[
              "Unfortunately, I cannot issue refunds.",
              "Would you like me to redirect you to a human support agent?",
            ]}
            className='tw-mt-2'
            delay={1}
          />
          <Bubble m={m} step='USER_2' sentences={["Yes, please!"]} variant='user' className='tw-mt-2' delay={1} />
          <Bubble m={m} step='AGENT_2' sentences={["Redirecting you now..."]} className='tw-mt-2' delay={1} />
        </>
      )}
    </ChatGuardrailsContainer>
  );
}
